import React, {useCallback, useEffect, useMemo, useState} from "react";
import IconButton from "../../../base/button/icon_button";
import {OpenInNew} from "@mui/icons-material";
import {Tab, Tabs} from "../../../base/Tabs";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import FloatingActionButtonNotebookContentTasks from "./tasks";
import FloatingActionButtonNotebookContentNotes from "./notes";
import {Link, useRouteMatch} from "react-router-dom";
import useAccessLevels from "../../../../hooks/use-access-levels";
import {useNotebookConfig} from "../../../../hooks/use-notebook-config";


const NoteBookFloatyTabs = {
    tasks: 'tasks',
    notes: 'notes',
}

const FloatingActionButtonNotebookContent = () => {
    const operatorAccessLevels = useAccessLevels();
    const {fabNotesVisible} = useNotebookConfig();
    const customerNotesPageMatch = useRouteMatch({path: routes.customer.notes, exact: true});
    const vendorNotesPageMatch = useRouteMatch({path: routes.vendor.notes, exact: true});
    const showTasksTab = operatorAccessLevels.packages.taskNote.tasks;
    const showNotesTab = operatorAccessLevels.packages.taskNote.notes
        && fabNotesVisible
        && !customerNotesPageMatch
        && !vendorNotesPageMatch;
    const defaultTab = showTasksTab ? NoteBookFloatyTabs.tasks : NoteBookFloatyTabs.notes;
    const [tab, setTab] = useState(defaultTab);

    const tabs = useMemo(() => {
        const entries = [];
        if (showTasksTab) {
            entries.push({value: NoteBookFloatyTabs.tasks, name: 'Tasks'});
        }
        if (showNotesTab) {
            entries.push({value: NoteBookFloatyTabs.notes, name: 'Notes'});
        }
        return entries;
    }, [showNotesTab, showTasksTab]);

    /**
     * Keeps the active tab valid when notes/tasks availability changes.
     */
    useEffect(() => {
        if (tab === NoteBookFloatyTabs.notes && !showNotesTab && showTasksTab) {
            setTab(NoteBookFloatyTabs.tasks);
        }
        if (tab === NoteBookFloatyTabs.tasks && !showTasksTab && showNotesTab) {
            setTab(NoteBookFloatyTabs.notes);
        }
    }, [showNotesTab, showTasksTab, tab]);

    /**
     * Handles changes in the selected tab and sets the tab index to the received [newValue] in the props
     * @param event
     * @param newValue
     */
    const onTabChange = useCallback((event, newValue) => {
        setTab(newValue);
    }, [])

    if (!showTasksTab && !showNotesTab) {
        return null;
    }

    return (
        <div className={'floaty-button-notebook-container'}>
            <div className={'floaty-button-notebook'}>
                <div className={'header'}>
                    <p>
                        Notebook
                    </p>
                    {
                        operatorAccessLevels.packages.taskNote.notebook &&
                        <IconButton
                            color={'paper.secondary'}
                            component={Link}
                            to={routes.notebook}
                        >
                            <OpenInNew className='icon normal'/>
                        </IconButton>
                    }
                </div>
                <div className={'mb-2'}/>
                {
                    showTasksTab && showNotesTab &&
                    <div className='w-100 flex-grow-1'>
                        <Tabs value={tab ?? false} onChange={onTabChange} aria-label="note book tabs">
                            {
                                tabs.map(({name, value}, index, array) => (
                                    <Tab key={value} label={name} value={value} minWidth={`${100 / array.length}%`}/>
                                ))
                            }
                        </Tabs>
                    </div>
                }
                <div className={'floaty-button-notebook-tab-content'}>
                    {
                        tab === NoteBookFloatyTabs.tasks && showTasksTab &&
                        <FloatingActionButtonNotebookContentTasks/>
                    }
                    {
                        tab === NoteBookFloatyTabs.notes && showNotesTab &&
                        <FloatingActionButtonNotebookContentNotes/>
                    }
                </div>
            </div>
        </div>
    );
}

export default FloatingActionButtonNotebookContent;
